// FRU-23403 (ab, 9/29): Hope's js_error telemetry had no per-page cap. On two iPhone visits one cross-origin
// "Script error." fired 486 Matomo events in about 14 seconds, and one visit reached 2,138 actions, past what Matomo's
// visit export returns. Every Hope error reporter (the Angular error handler and the chat's window error listener) now
// shares one budget per page load: at most HOPE_JS_ERROR_MAX events, and at most HOPE_JS_ERROR_MAX_SAME of one message.
// Errors past the budget are counted (window.__hopeJsErrorCap.dropped), never sent.
export const HOPE_JS_ERROR_MAX = 5;
export const HOPE_JS_ERROR_MAX_SAME = 2;

/** Whether this error may be reported: true until the page's budget, or this message's share of it, is spent. */
export function hopeJsErrorAllowed(message: any, w: any = (typeof window !== 'undefined' ? window : null)): boolean {
  try {
    if (!w) { return false; }
    const st = w.__hopeJsErrorCap = w.__hopeJsErrorCap || { total: 0, dropped: 0, seen: {} };
    const key = (message == null ? '' : String(message)).slice(0, 80);
    const same = st.seen[key] || 0;
    if (st.total >= HOPE_JS_ERROR_MAX || same >= HOPE_JS_ERROR_MAX_SAME) { st.dropped = (st.dropped || 0) + 1; return false; }
    st.total += 1;
    st.seen[key] = same + 1;
    return true;
  } catch (e) { return false; }
}
